import useOnLinkAnnotationPopupOpen from './useOnLinkAnnotationPopupOpen';

export default useOnLinkAnnotationPopupOpen;